import cx from 'classnames';
import React, { PropsWithChildren } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';

import s from './Dropdown.css';

type ComponentState = { isOpened: boolean };

type Props = {
    isOpened: boolean;
    button: (Component: ComponentState) => JSX.Element | null | undefined;
    handleMenu: () => void;
    buttonClass?: string;
    className?: string;
    dropdownClassName?: string;
    menuItemClassName?: string;
    disabled?: boolean;
    buttonDataTestId?: string;
    ariaLabel?: string;
};

export const Dropdown = ({
    isOpened,
    button,
    handleMenu,
    className,
    buttonClass,
    children,
    dropdownClassName,
    menuItemClassName,
    disabled,
    buttonDataTestId,
    ariaLabel,
}: PropsWithChildren<Props>): JSX.Element => {
    const ref = useOnclickOutside(() => {
        if (isOpened) {
            handleMenu();
        }
    });

    return (
        <div className={className}>
            <button
                type="button"
                className={buttonClass}
                onClick={handleMenu}
                disabled={disabled}
                data-testid={buttonDataTestId}
                aria-label={ariaLabel}
            >
                {button({ isOpened })}
            </button>
            {isOpened && (
                <div className={cx(s.dropdown, dropdownClassName)}>
                    {React.Children.toArray(children)
                        .filter(Boolean)
                        .map((item, index) => (
                            <div
                                ref={ref}
                                className={cx(s.menuItem, menuItemClassName)}
                                key={index}
                                onClick={handleMenu}
                            >
                                {item}
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
};
